module.exports = __webpack_public_path__ + "img/pokeball-icon.904626bd.png";